import styled from "styled-components"
import { minWidth } from "utils"

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;
`

export const Source = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  width: 100%;
`

export const TextAndCode = styled.div`
  width: 100%;
  font-size: 1.2rem;
  line-height: 1.9rem;
  text-align: center;
  color: #222222;

  ${minWidth.desktopXL`
    font-size: 1.4rem;
  `}
`

export const Code = styled.span`
  padding: 0.4rem 0.8rem;
  font-weight: 500;
  background-color: #EFEEE8;
  font-size: 1rem;

  ${minWidth.desktopXL`
    font-size: 1.2rem;
  `}
`

export const ViewButton = styled.a`
  width: 100%;
  padding: 1.3rem;
  border-radius: 10rem;
  display: block;
  font-size: 1.6rem;
  line-height: 2.2rem;
  letter-spacing: 0.1rem;
  font-weight: 500;
  text-align: center;
  color: #fff !important;
  background-color: ${({ theme }) => theme.colors.primaryOrange};
  text-transform: uppercase;
  white-space: nowrap;
`

export const SeeMoreOptions = styled.div`
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.35rem;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  text-align: center;
  color: #222222;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding: 1rem;
  margin-top: -1rem;
`
